module.exports = __webpack_public_path__ + "img/battery_3blue.60357b4f.png";